/**
 * OP Progress Scales: Finger Grip Test (FGT) includes `age` (often prefilled) and `action`,
 * so generic validation can allow "empty" saves. Validate explicitly on grip values/comments.
 */
export const isFgtScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "finger_grip_test";

export const hasFgtAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  // Age may be auto-filled; do not count it as user input.
  for (const k of ["left_hand", "right_hand"]) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    if (Number.isFinite(n) && n !== 0) return true;
  }

  return false;
};

